import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Observable } from 'rxjs';
import { SLIP_WIDTH, TOUCH_NONE } from '~/constant/ui.constant';
import { uiHelper } from '~/helpers/ui.helper';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CoreService } from '~/legacy/ts/services/core.service';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'mainFixtureView',
    templateUrl: './mainFixtureView.html',
})
export class MainFixtureView implements OnInit {
    SLIP_WIDTH: number = SLIP_WIDTH;

    styles = {
        main: { height: this.tournamentsService.Page_Window_Height - 75 + 'px' },
        fixtureArea: {
            width: this.tournamentsService.Page_Window_Width - SLIP_WIDTH - 34 + 'px',
            height: this.tournamentsService.Page_Window_Height - 75 + 'px',
        },
        header: {
            height: '70px',
            'padding-top': '5px',
            'padding-bottom': '5px',
        },
        rows: {
            'background-color': 'rgb(12, 12, 12)',
            height: this.tournamentsService.Page_Window_Height - 255 + 'px',
            'padding-top': '0px',
            'padding-bottom': '0px',
            'overflow-y': 'scroll',
            'padding-right': '0',
            'margin-right': '15px',
        },
        footer: {
            height: '110px',
            'background-color': 'burlywood',
            padding: '0px',
            'touch-action': 'none',
            'user-select': 'none',
        },
        bettingSlip: {
            height: this.tournamentsService.Page_Window_Height - 75 + 'px',
            'padding-top': '0px',
            'padding-left': '5px',
            'padding-right': '0px',
            'padding-bottom': '0px',
            width: SLIP_WIDTH + 'px',
            'margin-left': '15px',
        },
    };

    isLive = false;
    isPre = true;

    constructor(
        public tournamentsService: TournamentsService,
        private _uiHelper: uiHelper,
        private router: Router,
        private coreService: CoreService,
    ) {
        this.changeState(this.router.url);
        this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
            this.changeState(e['url']);
        });
    }

    changeState(e) {
        if (e === '/SportBets') {
            this.isLive = false;
            this.isPre = true;
        } else if (e === '/LiveBets') {
            this.isLive = true;
            this.isPre = false;
        } else if (e === '/' || e === 'index') {
            this.isLive = true;
            this.isPre = false;
        } else {
            // default for error handling
            // console.error('ROUTE ERROR FOR LIVE PRE SELECT');
            this.isLive = true;
            this.isPre = false;
        }
    }

    ngOnInit() {
        this.ClearSlipTimers();
    }

    ClearSlipTimers() {
        this.tournamentsService.SlipNumberControl = 0;
        this.tournamentsService.SlipCashOutSlipPasswordControl = 0;
        this.tournamentsService.cashOutButtonClick = 0;
        this.tournamentsService.payOutButtonClick = 0;
        this.tournamentsService.cashoutMessageTerminalActive = 0;
        this.tournamentsService.cashoutmessageTerminal = '';

        this.coreService.showOpenBetsVisible = 0;
        this.tournamentsService.cleanOpenBets_Timer();
    }

    sportSelected(selectedSportId) {
        this._uiHelper.setSportType(selectedSportId);
    }
}
